/** Board containers are storage details; profile IDs remain distinct records. */
export function flattenBrandCompetitors<T extends { id: number }>(groups: Array<T[] | undefined>): T[] {
  return Array.from(new Map(groups.flatMap(group => group ?? []).map(profile => [profile.id, profile])).values());
}
